import { render } from "./MoleculeInfos.vue?vue&type=template&id=8efdb386&scoped=true&ts=true"
import script from "./MoleculeInfos.vue?vue&type=script&lang=ts&setup=true"
export * from "./MoleculeInfos.vue?vue&type=script&lang=ts&setup=true"

import "./MoleculeInfos.vue?vue&type=style&index=0&id=8efdb386&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8efdb386"],['__file',"src/components/molecules/MoleculeInfos.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "8efdb386"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('8efdb386', __exports__)) {
    api.reload('8efdb386', __exports__)
  }
  
  module.hot.accept("./MoleculeInfos.vue?vue&type=template&id=8efdb386&scoped=true&ts=true", () => {
    api.rerender('8efdb386', render)
  })

}


export default __exports__